'use strict';
const angular = require('angular');

/*@ngInject*/
export function BankingAccountsService($resource) {
  return $resource('/api/banking-accounts/:id', {
    name: '@_id'
  },{
    getByUser: {
      method: 'GET',
      url: "/api/banking-accounts/user/:id",
      isArray: true
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.BankingAccountsService', [])
  .factory('BankingAccountsService', BankingAccountsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/banking-accounts/banking-accounts.service.js